const isProduction = process.env.VUE_APP_ENV_NAME === 'production';
const devMenuId = ['9769', '9770', '0099'];
const proMenu = ['9769', '9770', '0099'];
const titles = ['新闻动态', '市域标杆', '成果展示'];
export interface NewsItemTypes {
  id: number;
  classId: number;
  title: string;
  dataType: number;
  showType: number;
  publishTime: string;
  lastDoTime: number;
  imageUrl: string[];
  isVideo: number;
  videoUrl: string;
  videoTime: string;
  doLikeNum: number;
  isDoLike: number;
  isTop: number;
  label: string;
  plNum: string;
  interactNum: string;
  isAd: number;
  pv: string;
  imageNum: number;
  category: string;
  targetUrl: string;
  sourceImage: string;
  sourceName: string;
  smallText: string;
  traceInfo: string;
  traceId: string;
  contentLength: number;
  adId: number;
  buryValue: string;
  pcUrl: string;
}
export const toPage = (data: NewsItemTypes) => {
  // const baseUrl =
  //   process.env.VUE_APP_ENV_NAME === 'production'
  //     ? 'https://wap.cqcb.com/shangyou_news'
  //     : 'https://testwap.cqcb.com/shangyou_news';
  // window.location.href = `${baseUrl}/NewsDetail?classId=${data.classId}&newsId=${data.id}`;
  window.location.href = data.targetUrl;
};
export const getChannelList = () => {
  const ids = isProduction ? proMenu : devMenuId;
  return ids.map((id) => ({
    id,
    name: titles[ids.indexOf(id)],
  }));
};
export const getChannelList1 = () => {
  const ids = isProduction ? proMenu : devMenuId;
  return ids;
};
